export const APP_STAGE = process.env.REACT_APP_STAGE;
export const SITE_TITLE = process.env.REACT_APP_SITE_TITLE;
export const API_URL = process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const APP_LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
export const APP_LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL;
